<div class="sub-header">
    <span class="title">{{ 'SHARED.ROUTE.ACQUIRE.WIZARD.SELECTPARTNER' | translate}}</span>
</div>
<div class="list" *ngIf="partners">
    <shared-partner-acquire-route-item *ngFor="let item of partners; let i=index" [partner]="item"
        (click)="onSelectPartner(item)" class="item partnerItem monochrome reduced"
        [selected]="wizard.selectedPartner && wizard.selectedPartner.itemId==item.itemId">
    </shared-partner-acquire-route-item>
</div>